__webpack_require__.p = "/kanban-board/";